import { BoldIcon } from "components/common/Icons/BoldIcon";
import { useFindTextBox } from "../useFindTextBox";
import { useBold } from "./useBold";

export interface BoldProps {
    textBoxId: string;
}

export const Bold = ({ textBoxId }: BoldProps) => {
    const { textBox } = useFindTextBox(textBoxId);
    const { isActive, handleClick } = useBold(textBox);
    return (
        <button
            className={`w-10 h-10 flex items-center justify-center ${
                !isActive && "hover:bg-irGray-100 dark:hover:bg-darkSurface-300"
            } ${isActive ? "bg-irGray-200" : "bg-transparent"} rounded-lg`}
            onClick={handleClick}
        >
            <BoldIcon />
        </button>
    );
};
